export default __webpack_public_path__ + "static/media/glrc-course.holistic-cooking-dietary-restrictions.b82885f0.png";